import React, { useMemo } from 'react'
import InlineSVG from 'react-inlinesvg';
import PhoneInput from 'react-phone-input-2'

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const PhoneV2Field = ({
    value,
    onChange,
    isDisabled,
    onBlur,
    onFocus,
    aria,
    classes,
    styles,
    errorMessage,
    id,
    name,
    hasError,
    valid,
}) => {
    const country = typeof window !== 'undefined' ? localStorage?.getItem?.('country') : null;
    const countryTwoLetter = typeof window !== 'undefined' ? localStorage?.getItem?.('countryTwoLetter') : null;

    const ctr = useMemo(() => {
        if (country) {
            if (country === 'uk' && countryTwoLetter) return countryTwoLetter;
            if (country === 'denmark') return 'dk';
            if (country === 'sweden') return 'se';
            if (country === 'uk') return 'gb';
        }

        return 'se';
    }, [])

    return (
        <div className='formV2-field-input-phone-wrapper'>
            <PhoneInput
                inputProps={{
                    id,
                    name,
                    autoComplete: 'tel'
                }}
                onBlur={onBlur}
                onFocus={onFocus}
                value={value}
                onChange={(e, data) => {
                    if (e[0] === '0' && e[1] === '0') {
                        e = '+' + e.substring(2);
                    }

                    if (e[0] === '0' && e[1] !== '0') {
                        e = '+' + data.dialCode + e.substring(1);
                    }

                    if (e.startsWith(data.dialCode + '0')) {
                        e = e.replace(data.dialCode + '0', data.dialCode);
                    }

                    onChange?.(e);
                }}
                enableLongNumbers={true}
                autoFormat={true}
                disabled={isDisabled}
                {...aria || {}}
                country={ctr}
                containerClass={`${classes?.field || ''}`}
                containerStyle={styles?.field}
                inputClass={hasError || valid ? 'formV2-field-input-phone-invalid' : ''}
            />
            {hasError || valid ? <div aria-hidden='true' className='formV2-field-input-error-icon'>
                {hasError ? <InlineSVG
                    src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e"
                /> : valid ? <InlineSVG
                    src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e"
                /> : null}
            </div> : null}
        </div>
    )
}

export default PhoneV2Field